import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  RadialBarChart,
  RadialBar,
} from "recharts";
import { BASE_URL } from "../../config/axios";
import { handleErrorToast } from "../CustomFunctions";
import { ToastContainer } from "react-toastify";
import { CasualLeaveIcon, PreviousLeaveIcon, ShortLeaveIcon, SickLeaveIcon, Trophy } from "../AllSvg";

const BalanceAndRequestsBoard = ({ viewType = "both", customHeight = 'auto', customWidth = 'auto', customStyle, cardStyle, cardWidth }) => {
  const [leavebalance, setLeavebalance] = useState({});
  const getLeavebalance = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/leavebalance/${sessionStorage.getItem("emp_code")}/`);
      setLeavebalance(res.data);
    } catch (err) {
      // handleErrorToast(err)
    }
  };

  const getEmpAttendance = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/star-performance-attendance-rating-employee-wise/?start_month_year=2026-1&end_month_year=2026-2&empcode=${sessionStorage.getItem("emp_code")}`);
    } catch (err) {
      // handleErrorToast(err)
    }
  };

  useEffect(() => {
    if (viewType === "both" || viewType === "leaves") {
      getLeavebalance();
      getEmpAttendance();
    }
  }, [viewType]);

  const [chartData, setChartData] = useState({});
  const getChartdata = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/pendingitems/${sessionStorage.getItem('emp_code')}`);
      setChartData(res.data);
    } catch (err) {
      handleErrorToast(err)
    }
  };

  useEffect(() => {
    if (viewType === "both" || viewType === "requests") {
      getChartdata();
    }
  }, [viewType]);

  const data = [
    { name: "Max", value: 100.0, fill: "#fff" },
    { name: "Leave", value: chartData.leave_details, total: chartData.leave_details_total, fill: "#FF747C" },
    { name: "Compensatory", value: chartData.compensatory_request, total: chartData.compensatory_requests_total, fill: "#F7BA1E" },
    { name: "Outduty", value: chartData.outduty_details, total: chartData.outduty_details_total, fill: "#165DFF" },
  ];

  return (
    <>
      {(viewType === "both" || viewType === "leaves") && (

        <div className={`flex-column piechartt ${!cardWidth ? 'leave-balance-cards-leaves' : ''}`} style={{ marginBottom: '20px', width: cardWidth ? 'auto' : '100%' }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>Available Leaves:</span>
          <div className="leave-balance-container-dashnboard">
            <div className="leave-balance-cards-available-leaves" style={{ ...customStyle }}>
              <div style={{ ...cardStyle }} className="leave-balance-card-available-leaves leave-balance-card-previous">
                <div className="leave-balance-icon-available-leaves"><PreviousLeaveIcon /></div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Previous Leave : {" "}</span>
                  <span className="leave-balance-duration">
                    {leavebalance.leavebalance ? `${leavebalance.leavebalance} ${leavebalance.leavebalance > 1 ? 'days' : 'day'}` : "0 day"}
                  </span>
                </div>
              </div>

              <div style={{ ...cardStyle }} className="leave-balance-card-available-leaves leave-balance-card-casual">
                <div className="leave-balance-icon-available-leaves"><CasualLeaveIcon /></div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Casual Leave : {" "}</span>
                  <span className="leave-balance-duration">
                    {leavebalance.casual_leave ? `${leavebalance.casual_leave} ${leavebalance.casual_leave > 1 ? 'days' : 'day'}` : "0 day"}
                  </span>
                </div>
              </div>

              <div style={{ ...cardStyle }} className="leave-balance-card-available-leaves leave-balance-card-sick">
                <div className="leave-balance-icon-available-leaves"><SickLeaveIcon /></div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Sick Leave : {" "}</span>
                  <span className="leave-balance-duration">
                    {leavebalance.sick_leave ? `${leavebalance.sick_leave} ${leavebalance.sick_leave > 1 ? 'days' : 'day'}` : "0 day"}
                  </span>
                </div>
              </div>

              <div style={{ ...cardStyle }} className="leave-balance-card-available-leaves leave-balance-card-earned">
                <div className="leave-balance-icon-available-leaves"><Trophy /></div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Earned Leave : {" "}</span>
                  <span className="leave-balance-duration">
                    {leavebalance.earn_leave ? `${leavebalance.earn_leave} ${leavebalance.earn_leave > 1 ? 'days' : 'day'}` : "0 day"}
                  </span>
                </div>
              </div>

              <div style={{ ...cardStyle }} className="leave-balance-card-available-leaves leave-balance-card-short">
                <div className="leave-balance-icon-available-leaves"><ShortLeaveIcon /></div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Short Leave : {" "}</span>
                  <span className="leave-balance-duration">
                    {leavebalance.short_leave ? `${leavebalance.short_leave} ${leavebalance.short_leave > 1 ? 'days' : 'day'}` : "0 day"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {(viewType === "both" || viewType === "requests") && (
        <div className="flex-column piechartt" style={{ height: customHeight ? customHeight : 'auto', width: customWidth ? customWidth : 'auto' }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b", borderBottom: "1px solid #F0F4F8", paddingBottom: '5px' }}>Inprocess Requests:</span>
          <div className="leave-balance-container-dashnboard" style={{ marginTop: '0px', marginBottom: '10px' }}>
            <div className="form-flex-wrap justify-evenly">
              {data.map((item, index) => {
                if (item.name === "Max") return null;
                return (
                  <div key={index} className="radialchart-legend">
                    <div className="radialchart-dot" style={{ backgroundColor: item.fill }}></div>
                    <div className="flex-row">
                      <div className="radialchart-subheading font-weight400 font-size-text">{item.name} - </div>
                      <div className="radialchart-subheading font-weight600 font-size-text"> {item.value}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
    </>
  );
};

export default BalanceAndRequestsBoard;